var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var HtmlBoxStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1.4px solid #ccc;\n  padding: 0.5rem;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 1rem;\n"], ["\n  border: 1.4px solid #ccc;\n  padding: 0.5rem;\n  max-height: 300px;\n  overflow-y: auto;\n  margin-bottom: 1rem;\n"])));
var templateObject_1;
